import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonMenuButton,
  IonContent,
} from '@ionic/react';
import StockContent from '../components/StockContent';

const Stock: React.FC = () => (
  <IonPage>
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton menu="main-menu" />
        </IonButtons>
        <IonTitle>Stock</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent fullscreen className="bg-gray-50 dark:bg-gray-900">
      <StockContent />
    </IonContent>
  </IonPage>
);

export default Stock;
